import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogResult } from '../../models/enums/dialog-result/dialog.result';
import { IncidentStatus } from '../../../api/generated/v2/incident';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './close-incident-modal.component.html',
    styleUrls: ['./close-incident-modal.component.scss'],
    standalone: false
})
export class CloseIncidentModalComponent {

  selectedState: IncidentStatus;

  public unclearStates: IncidentStatus[] = [
    IncidentStatus.Aborted
  ];

  public faultFixedStates: IncidentStatus[] = [
    IncidentStatus.FaultFixed,
    IncidentStatus.FaultFixedProvisionalSolution,
    IncidentStatus.FaultNotFound,
  ];

  public notPossibleStates: IncidentStatus[] = [
    IncidentStatus.PoleNotAccessible
  ];

  constructor(
    public dialogRef: MatDialogRef<CloseIncidentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected sanitizer: DomSanitizer,
    protected iconRegistry: MatIconRegistry,
  ) {
    iconRegistry.addSvgIcon('qm', sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/question-mark.svg'));
    this.selectedState = IncidentStatus.Aborted;
  }

  public onClsBtnClick(): void {
    this.close(DialogResult.CLOSED);
  }

  public onRevokeBtnClick(): void {
    this.close(DialogResult.NO);
  }

  public onConfirmBtnClick(): void {
    this.close(DialogResult.YES);
  }

  selectedStateChanged(newState: IncidentStatus) {
    if (!newState) { return; }

    this.selectedState = newState;
  }

  private close(res: DialogResult): void {
    const response = {
      dialogResult: res,
      selectedState: this.selectedState
    };

    this.dialogRef.close(response);
  }
}
